export default __webpack_public_path__ + "static/inventory_management-a7964b705e0419cec08501c90e5cea75.png";